"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var GoogleAnalytics_provider_1 = require("./GoogleAnalytics.provider");

exports.googleAnalyticsProvider = GoogleAnalytics_provider_1.googleAnalyticsProvider;